import React, { useState, useEffect } from 'react';
import './DiscardedBookList.css';
import * as Constants from '../../Constant/constant';

function DiscardedBookList() {
    const [discardedBooks, setDiscardedBooks] = useState([]);
    const [activeBooks, setActiveBooks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showDiscardModal, setShowDiscardModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;

    useEffect(() => {
        fetchDiscardedBooks();
    }, []);

    const fetchDiscardedBooks = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${Constants.API_PATH}/discarded-books`);
            const data = await response.json();
            setDiscardedBooks(data);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchActiveBooks = async () => {
        try {
            const response = await fetch(`${Constants.API_PATH}/book_list`);
            const data = await response.json();
            setActiveBooks(data);
        } catch (error) {
            console.error('Failed to fetch active books:', error.message);
        }
    };

    const handleOpenDiscardModal = () => {
        fetchActiveBooks();
        setShowDiscardModal(true);
    };

    const handleCloseDiscardModal = () => {
        setShowDiscardModal(false);
    };

    const discardBook = async (bookId) => {
        if (window.confirm('Are you sure you want to discard this book?')) {
            try {
                const response = await fetch(`${Constants.API_PATH}/discard-book/${bookId}`, {
                    method: 'PUT',
                });
                if (!response.ok) {
                    throw new Error('Failed to discard book');
                }
                alert('Book discarded successfully!');
                handleCloseDiscardModal();
                fetchDiscardedBooks(); // Refresh after discard
            } catch (error) {
                console.error('Discard error:', error.message);
                alert('Failed to discard book');
            }
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < Math.ceil(discardedBooks.length / entriesPerPage)) setCurrentPage(currentPage + 1);
    };

    const indexOfLastItem = currentPage * entriesPerPage;
    const indexOfFirstItem = indexOfLastItem - entriesPerPage;
    const currentBooks = discardedBooks.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div className="discarded-book-list-section containernew">
            <div className="header-section">
                <h2 className="section-title">Discarded Book List</h2>
                
                <button className="newbtn" onClick={handleOpenDiscardModal}>Discard New Book</button>
               
            </div>
             <br/>
            <div className="table-container">
                {loading ? (
                    <p className="loading-message">Loading discarded books...</p>
                ) : error ? (
                    <p className="error-message">{error}</p>
                ) : (
                    <table className="data-table custom-table">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Name</th>
                                <th>Book Code</th>
                                <th>Author</th>
                                <th>Publisher</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentBooks.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="no-data">No discarded books found</td>
                                </tr>
                            ) : (
                                currentBooks.map((book, index) => (
                                    <tr key={book.id}>
                                        <td>{indexOfFirstItem + index + 1}</td>
                                        <td>{book.book_name}</td>
                                        <td>{book.book_code}</td>
                                        <td>{book.author}</td>
                                        <td>{book.publisher}</td>
                                        <td>{book.book_location}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                )}
            </div>

            {/* Pagination */}
            {discardedBooks.length > entriesPerPage && (
                <div className="pagination-controls">
                    <button onClick={handlePreviousPage} disabled={currentPage === 1}>Previous</button>
                    <span>Page {currentPage} of {Math.ceil(discardedBooks.length / entriesPerPage)}</span>
                    <button onClick={handleNextPage} disabled={currentPage >= Math.ceil(discardedBooks.length / entriesPerPage)}>Next</button>
                </div>
            )}

            {/* Modal for Discarding Book */}
            {showDiscardModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <span className="close" onClick={handleCloseDiscardModal}>&times;</span>
                        <h3>Select Book to Discard</h3>
                        <div className="modal-book-list">
                            {activeBooks.length === 0 ? (
                                <p>No active books available</p>
                            ) : (
                                <table className="data-table custom-table">
                                    <thead>
                                        <tr>
                                            <th>Book Name</th>
                                            <th>Author</th>
                                            <th>Publisher</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {activeBooks.map((book) => (
                                            <tr key={book.id}>
                                                <td>{book.book_name}</td>
                                                <td>{book.author}</td>
                                                <td>{book.publisher}</td>
                                                <td>
                                                    <button onClick={() => discardBook(book.id)}>Discard</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default DiscardedBookList;
